import { CSSObject, IconProps } from '@chakra-ui/react';
import { BottomRowSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/BottomRow/styles/BottomRow.styles';

export const bottomRowStyles: BottomRowSchema = {
  flexWrapper: {
    w: '100%',
  },
  buttonCashOutDesc: {
    w: '100%',
    height: '29px',
    fontWeight: 'normal',
    fontSize: 'sm',
    textTransform: 'capitalize',
    color: 'alpha.900',
    sx: {
      '.cashoutValue': {
        color: 'alpha.900',
      },
      '&:active, &:hover': {
        '.cashoutValue': {
          color: 'alpha.900',
        },
      },
    },
  },
  buttonCashOutAmount: {
    variant: 'primary',
    height: '29px',
    fontFamily: 'Staatliches',
    fontWeight: 'normal',
    _hover: {
      bgGradient: 'linear(180deg, beta.400 0%, beta.500 100%)',
      textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
      color: 'beta.900',
    },
  },
  flexOddsBoostBanner: {
    bg: 'alpha.800',
    color: 'beta.300',
    sx: {
      svg: {
        color: 'beta.300',
        fill: 'beta.300',
      },
    },
  },
  textOddsBoost: {
    color: 'beta.300',
    fontFamily: 'accent',
    fontWeight: 'semibold',
    pt: '2px',
  },
  vstackBetsWrapper: {
    w: '100%',
    ml: 'inherit',
  },
  buttonGroupWrapper: {
    w: '100%',
  },
  iconCashOut: {
    fill: 'currentColor',
  },
  cashoutText: {
    color: 'currentColor',
    pt: '1',
    fontWeight: 'bold',
  },
  cashoutValue: {
    pt: '1',
    fontWeight: 'bold',
  },
};
export const LinkVenueName: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'normal',
  ml: '26px',
};
export const RaceTime: CSSObject = {
  color: 'white',
  fontWeight: 'medium',
  alignSelf: 'flex-end',
  ml: '26px',
};
export const BonusBetCheckMark: CSSObject = {
  '&&': {
    display: 'none',
  },
};
export const BonusBetText: CSSObject = {
  color: 'beta.300',
  fontSize: 'xs',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  fontFamily: 'accent',
  bg: 'alpha.800',
  borderRadius: 'md',
  boxShadow:
    '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
  px: '2',
  pt: '2',
  pb: '2',
  lineHeight: 'normal',
};
export const BetReturn: CSSObject = {
  bg: 'blackAlpha.500',
  color: 'beta.300',
  borderRadius: 'base',
  fontWeight: 'medium',
  fontSize: '2xs',
  boxShadow:
    '0px 2px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(16, 128, 157, 1) inset',
};
export const BoxBetReturnValue: CSSObject = {
  py: '0.5',
  p: '1',
  fontWeight: 'bold',
};
export const BoxBetReturnText: CSSObject = {
  my: '1',
  px: '1',
  borderRight: '1px solid',
  borderRightColor: 'blackAlpha.400',
};
export const iconLegProps: IconProps = {
  boxSize: '18px',
  color: 'gray.400',
  bg: 'white',
  borderColor: 'white',
};
